import React, { useState } from "react";
import info from "../../../../assets/icons/info-circle-white.svg";
import * as Library from "../../../../utils/Library";
import FormField from "../../../common/forms/FormField";
import { StepFormStyle } from "../ApiPage";

const ConnectedFieldPopup = ({
    handleConnectedFieldChange,
    connectedFieldDetails,
    resetConnectedFieldDetails,
    handleGetConnectedFieldsData,
    registerYesHandler,
    posID,
    environmentName,
    setConnectedFieldLoader
}) => {
    // #region STATES
    const [connectedFieldTypes] = useState([
        { name: "BOtag", value: "BOtag", selected: false },
        { name: "LabelBrand", value: "LabelBrand", selected: false },
        { name: "RetailBrand", value: "RetailBrand", selected: false },
        { name: "Store", value: "Store", selected: false },
        { name: "POS key", value: "POS key", selected: false }
    ]);
    // #endregion

    // #region METHODS
    registerYesHandler(async () => {
        if (connectedFieldDetails?.predefinedValue === "") delete connectedFieldDetails.predefinedValue;
        Library.makeApiRequest({
            data: {
                connectFieldData: connectedFieldDetails,
                posID,
                environmentName
            },
            endpoint: "createConnectField",
            setLoader: setConnectedFieldLoader
        }).then(res => {
            if (res?.data?.status === 200) {
                handleGetConnectedFieldsData();
                resetConnectedFieldDetails();
                Library.showToastMessage({
                    type: "success",
                    title: "ConnectField has been created!"
                });
            } else {
                Library.showToastMessage({
                    type: "error",
                    title: "Failed to create ConnectField!"
                });
            }
        });
    });
    // #endregion
    return (
        <StepFormStyle>
            <FormField
                type="text"
                title="Connect Field Name"
                tooltip="Connect Field Name"
                requiredType="mandatory"
                assistiveText=""
                varName="name"
                value={connectedFieldDetails?.name}
                onTextChange={e => {
                    handleConnectedFieldChange("name", e);
                }}
            />
            <FormField
                type="dropdown"
                title="Type"
                tooltip="Type"
                dropdownData={connectedFieldTypes}
                requiredType="mandatory"
                value={connectedFieldDetails?.type}
                onTextChange={e => {
                    handleConnectedFieldChange("type", e.value);
                }}
                assistiveText=""
                varName="type"
            />

            {connectedFieldDetails?.type === "BOtag" && (
                <div>
                    <div className="align-items-center gap-8px mb-5px">
                        <div>BOTAG KEY</div> <img alt="" src={info} style={{ height: "12px" }} />
                    </div>
                    <FormField
                        type="text"
                        title="BOtag Key Value"
                        tooltip="BOtag Key Value"
                        assistiveText=""
                        requiredType="mandatory"
                        varName="value"
                        value={connectedFieldDetails?.predefinedValue}
                        onTextChange={e => {
                            handleConnectedFieldChange("predefinedValue", e);
                        }}
                    />
                </div>
            )}
        </StepFormStyle>
    );
};

export default ConnectedFieldPopup;
